module.exports = __webpack_public_path__ + "img/s5-right-hand.ceeefa23.png";